// @core/api/endpoints/project/get_project_summary.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetProjectSummaryResponse,
} from '../../../types/project';

const BASE_PATH = '/project';

/**
 * Get project summary
 * Returns a compact project snapshot optimized for agent context loading: progress, blockers, active sprint, next milestone, team workload, and recent activity. Designed to fit in a single LLM context window.
 */
export async function GetProjectSummary(
  project_id: string,
  options?: RequestOptions
): Promise<GetProjectSummaryResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/summary`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  const requestOptions = options;
  return client.get<GetProjectSummaryResponse>(requestPath, { ...requestOptions });
}
